import React, { useState, useEffect } from "react";
import { Card, Col, Row, Typography, message } from "antd";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import BioTabs from "../components/layout/BioTabs";
import AdminManageDevice from "../components/layout/AdminManageDevice";
import ManageVendors from "../components/layout/ManageVendors";
import { getAPI } from "../config/api/apiConfig";
import { setUserId } from "../redux/feature/auth/auth";

const { Title } = Typography;

const Home = () => {

  const role = useSelector((state) => state.authenticate.role);
  const history = useHistory();
  const fullName = useSelector((state) => state.authenticate.fullName);
  const email = useSelector((state) => state.authenticate.username);
  const token = useSelector((state) => state.authenticate.userToken);
  const userId = useSelector((state) => state.authenticate.userId);



  const dispatch = useDispatch();

  const fetchUserId = async () => {
    try {
      const account = await getAPI(`get-account-email/${email}`, token);
      dispatch(setUserId(account.data?.data?.id));
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    const isLoggedIn = localStorage.getItem("isLoggedIn") === "true";
    if (isLoggedIn) {
      history.replace("/dashboard");
    }
  }, [history]);

  useEffect(() => {
    if (!userId) {
      fetchUserId();
    }
  }, [ email, token, userId]); // Only include necessary dependencies




  return (
    <div className="layout-content">
      <Row gutter={[24, 0]} style={{ maxHeight: "85vh", height: "85vh" }}>
        <Col
          xs={24}
          md={24}
          sm={24}
          lg={24}
          xl={24}
          className="mb-24"
          style={{ paddingRight: "2em" }}
        >
          <Card
            bordered={false}
            className="criclebox h-full"
            style={{ paddingTop: 10, paddingLeft: 20, paddingRight: 20 }}
          >
            <Row gutter>
            {role === "Scanner_Ticket" && (
                  <h1 className="head-title">Biometric Certification</h1>
                )}
              <Col xs={24} md={24} sm={24} lg={24} xl={24}>
                <Title level={4}>Welcome <span className="user">{fullName}</span></Title>
                {role === "Nibss_Super_Cert01" && (
                  <div>
                  <Title className="role" level={4}>Super Admin Dashboard</Title>
                  </div>
                )}
                {role === "Nibss_Admin_Ticket" && (
                  <div >
                  <Title  className="role" level={4}>Admin Dashboard</Title>
                  </div>
                )}
                {role === "Scanner_Ticket" && (
                  <Title className="role" level={4}>Vendor Dashboard</Title>
                )}
                
              </Col>
              <Col
                xs={24}
                md={24}
                sm={24}
                lg={24}
                xl={24}
                className="mobile-24"
                style={{ height: "100%", overflowY: "scroll" }}
              >
                {role === "Nibss_Super_Cert01" ? (
                  <AdminManageDevice />
                ) : role === "Nibss_Admin_Ticket" ? (
                  <BioTabs />
                ) : role === "Scanner_Ticket" ? (
                  <ManageVendors />
                ) : null}
              </Col>
            </Row>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default Home;
